<template>
    <div>
        <Box  @close="cerrar(false)">
            <template #top>Nuevo Usuario</template>
            <template #center>
                <div class="nj-card nj-cols form c2 l-c3">
                    <div>
                        <div class="nj-label">Tipo</div>
                        <select class="nj-select" v-model="usuario.tiu_id">
                            <option v-for="item in tipos_usaurio" :key="item.tiu_id" :value="item.tiu_id">{{ item.tiu_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Nombre</div>
                        <input type="text" class="nj-text" v-model="usuario.usu_nombre">
                    </div>
                    <div>
                        <div class="nj-label">Apellido</div>
                        <input type="text" class="nj-text" v-model="usuario.usu_apellido">
                    </div>
                    <div>
                        <div class="nj-label">DNI</div>
                        <input type="text" class="nj-text" v-model="usuario.usu_dni">
                    </div>
                    <div>
                        <div class="nj-label">Correo electrónico</div>
                        <input type="text" class="nj-text" v-model="usuario.usu_correo">
                    </div>
                    <div>
                        <div class="nj-label">Password</div>
                        <input type="password" class="nj-text" v-model="usuario.usu_password">
                    </div>
                    <div>
                        <div class="nj-label">Nivel</div>
                        <select class="nj-select" v-model="usuario.usu_nivel">
                            <option v-for="item in lista_usuario_nivel" :key="item.niu_id" :value="item.niu_id">{{ item.niu_nombre }}</option>
                        </select>
                    </div>
                    <div>
                        <div class="nj-label">Roles</div>
                        <select class="nj-select" multiple v-model="id_roles">
                            <option v-for="item in roles" :key="item.rol_id" :value="item.rol_id">{{ item.rol_nombre }}</option>
                        </select>
                    </div>
                </div>
            </template>
            <template #bottom>
                <button class="nj-button c-green" @click="registrar()"><i class="mdi mdi-content-save"></i>Registrar</button>
            </template>
        </Box>
    </div>
</template>

<script>
import RolService from "../../services/RolService"
import Toast from "../../util/toast"
import { UsuarioService } from "../../rest"
import TipoUsuario from "../../constants/tipoUsuario"
import { Buttons, Box } from "../components"
import { AppService, ResponseStatus } from "../../rest"

export default {
    name: "RegistrarUsuario",
    components: {
        Buttons,
        Box,
    },
    data() {
        return {
            usuario: {
                usu_nombre: null,
                usu_apellido: null,
                usu_dni: null,
                usu_correo: null,
                usu_password: null,
                usu_nivel: null,
                lista_usuario_rol: []
            },
            roles: [],
            puestos: [],
            tipos_usaurio: [],
            lista_usuario_nivel: [],
            id_roles: [],
        }
    },
    methods: {
        registrar() {
            let errors = 0
            this.id_roles.forEach(item => {
                this.usuario.lista_usuario_rol.push({
                    rol_id: item
                })
            })
            if (this.usuario.usu_nombre == null) errors++
            if (this.usuario.usu_apellido == null) errors++
            if (this.usuario.usu_dni == null) errors++
            if (this.usuario.usu_correo == null) errors++
            if (this.usuario.usu_password == null) errors++
            if (this.usuario.usu_nivel == null) errors++
            if (this.usuario.lista_usuario_rol.length == 0) errors++
            if (errors == 0) {
                UsuarioService.registrar(this.usuario).then(
                    response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.cerrar()
                        } else {
                            Toast.warn(response.message)
                        }
                    },
                    error => {
                        Toast.error(error)
                        console.error(`error: `, error)
                    }
                )
            } else {
                Toast.warn("Faltan ingresar datos")
            }
        },
        cerrar(condition) {
            this.$emit("close", condition)
        }
    },
    mounted() {
        // cargando tipos de usuario
        this.tipos_usaurio.push(TipoUsuario.data.EMPLEADO)
        this.usuario.tiu_id = 1
        // cargando niveles
        AppService
            .getData(["niveles_usuario"])
            .then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.lista_usuario_nivel = response.data.niveles_usuario
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        // cargando los roles
        RolService.buscar().then(
            response => {
                this.roles = response.data
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>